export const SHUFFLE_CARDS_COUNT = new Array(45).fill(null).map((item, index) => index);
export const ANIMATION_DURATION = 2;
export const GAME_CONTROLLER_TYPES_YET = {
  BETS: 'BETS',
};
export const GAME_RULES_HELP_KEYS_TURBO = new Array(8).fill(null).map((item, index) => index);

export const CONNECTION_METHOD_NAMES = {
  LIVE_BETS_RESULT: 'LiveBetsResult',
  HOLD: 'Hold',
  CASH_OUT: 'Cashout',
  HOLD_RESULT: 'HoldResult',
  CASH_OUT_RESULT: 'CashoutResult',
  DO_DEMO_BET: 'DoDemoBet',
  DEMO_HOLD: 'DemoHold',
  DEMO_CASH_OUT: 'DemoCashout',
  DEMO_BET_RESULT: 'DemoBetResult',
  DEMO_HOLD_RESULT: 'DemoHoldResult',
  DEMO_CASH_OUT_RESULT: 'DemoCashoutResult',
  GET_GAMBLE_CARDS: 'GetGambleCards',
  GET_DEMO_GAMBLE_CARDS: 'GetDemoGambleCards',
  GAMBLE: 'Gamble',
  DEMO_GAMBLE: 'DemoGamble',
  GAMBLE_CARDS_RESULT: 'GambleCardsResult',
  DEMO_GAMBLE_CARDS_RESULT: 'DemoGambleCardsResult',
  GAMBLE_RESULT: 'GambleResult',
  DEMO_GAMBLE_RESULT: 'DemoGambleResult',
};

export const GAMBLE_TYPES = ['x2', 'x4'];

export const GAMBLE_TYPES_ODD = {
  0: 2,
  1: 4,
};

export const TURBO_GAME_ID = 52;
